module.exports = __webpack_public_path__ + "img/263A.1df58ea8.svg";